export default {
  root: ({ state, instance }) => ({
    class: [
      // Shape
      'shadow-lg',
      'border-0',
      'overflow-hidden',

      // Size and Background Colour
      {
        'bg-background-light-base h-full': instance.$attrs['full-screen'],
        'm-0 bg-white rounded-xl max-h-[75vh]': !instance.$attrs['full-screen'],
        'max-w-xl 3xl:max-w-[720px]': !instance.$attrs['custom-width'],
      },

      // Transitions
      'transform',
      'scale-100',

      // Maximized State
      {
        'transition-none': state.maximized,
        'transform-none': state.maximized,
        'w-screen!': state.maximized,
        'h-screen!': state.maximized,
        'max-h-full!': state.maximized,
        'top-0!': state.maximized,
        'left-0!': state.maximized,
      },
    ],
  }),
  header: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-between',
      'shrink-0',

      // Spacing
      'py-6 px-2 lg:p-6',

      // Shape
      'border-t-0',
      'rounded-tl-lg',
      'rounded-tr-lg',
      'border-b border-gray-200',

      // Colors
      'bg-surface-0',
      'text-base-colours',
    ],
  },
  title: {
    class: ['font-bold text-base-colour'],
  },
  icons: {
    class: ['flex items-center'],
  },
  closeButton: {
    class: [
      'relative',

      // Flexbox and Alignment
      'flex items-center justify-center',

      // Size and Spacing
      'ml-auto',
      'last:mr-0',
      'w-8 h-8',

      // Shape
      'border-0',
      'rounded-full',

      // Colors
      'text-base-colours',
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-inset',
      'focus:ring-primary-400/50',

      // Misc
      'overflow-hidden',
    ],
  },
  maximizablebutton: {
    class: [
      'relative',

      // Flexbox and Alignment
      'flex items-center justify-center',

      // Size and Spacing
      'mr-2',
      'last:mr-0',
      'w-8 h-8',

      // Shape
      'border-0',
      'rounded-full',

      // Colors
      'text-surface-500',
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:text-surface-700',
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-inset',
      'focus:ring-primary-400/50',

      // Misc
      'overflow-hidden',
    ],
  },
  closeButtonIcon: {
    class: [
      //Colour
      'text-base-colour hover:text-brand-green',
      // Display
      'inline-block',

      // Size
      'w-4',
      'h-4',
    ],
  },
  maximizableicon: {
    class: [
      // Display
      'inline-block',

      // Size
      'w-4',
      'h-4',
    ],
  },
  content: ({ state, instance }) => ({
    class: [
      // Spacing
      'pb-6',
      'pt-0',
      { 'mx-auto': instance.$attrs['centered'] },
      { 'p-0': instance.$attrs['no-padding'] },
      { 'px-4': !instance.$attrs['no-padding'] },

      // Shape
      {
        grow: state.maximized,
        'rounded-bl-lg': !instance.$slots.footer,
        'rounded-br-lg': !instance.$slots.footer,
        // --- When showHeader is false, round the top corners of the modal ---
        'rounded-tl-lg': !instance.$slots.header,
        'rounded-tr-lg': !instance.$slots.header,
        // ---------------------------
      },

      // Colors
      'bg-surface-0',
      'text-base-colours',

      // Misc
      'overflow-y-auto',
    ],
  }),
  footer: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-end',
      'shrink-0',
      'text-right',
      'gap-2',
      'mx-auto',
      'border-t border-gray-200 w-full',

      // Spacing
      'px-6',
      'pb-6',

      // Shape
      'rounded-b-lg',

      // Colors
      'bg-surface-0',
      'text-surface-700',
    ],
  },
  mask: ({ props, state }) => ({
    class: [
      // Transitions
      'transition',
      'duration-200',
      { 'xl:p-5 p-2': !state.maximized },

      // Background and Effects
      { 'bg-black/40': props.modal, 'backdrop-blur-sm': props.modal },
    ],
  }),
  transition: ({ props }) => {
    return props.position === 'top'
      ? {
          enterFromClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
          enterActiveClass: 'transition-all duration-200 ease-out',
          leaveActiveClass: 'transition-all duration-200 ease-out',
          leaveToClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
        }
      : props.position === 'bottom'
        ? {
            enterFromClass: 'opacity-0 scale-75 translate-y-full',
            enterActiveClass: 'transition-all duration-200 ease-out',
            leaveActiveClass: 'transition-all duration-200 ease-out',
            leaveToClass: 'opacity-0 scale-75 translate-x-0 translate-y-full translate-z-0',
          }
        : props.position === 'left' ||
            props.position === 'topleft' ||
            props.position === 'bottomleft'
          ? {
              enterFromClass: 'opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0',
              enterActiveClass: 'transition-all duration-200 ease-out',
              leaveActiveClass: 'transition-all duration-200 ease-out',
              leaveToClass: 'opacity-0 scale-75  -translate-x-full translate-y-0 translate-z-0',
            }
          : props.position === 'right' ||
              props.position === 'topright' ||
              props.position === 'bottomright'
            ? {
                enterFromClass: 'opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0',
                enterActiveClass: 'transition-all duration-200 ease-out',
                leaveActiveClass: 'transition-all duration-200 ease-out',
                leaveToClass:
                  'opacity-0 scale-75 opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0',
              }
            : {
                enterFromClass: 'opacity-0 scale-75',
                enterActiveClass: 'transition-all duration-200 ease-out',
                leaveActiveClass: 'transition-all duration-200 ease-out',
                leaveToClass: 'opacity-0 scale-75',
              };
  },
};
